import React, { useEffect } from 'react'
import { graphql } from 'gatsby'
import { mapAnimations, filterFragmentByTags } from '../components/utils'

import Layout from '../components/layout'
import Section from '../components/section/section'
import SectionNav from '../components/navigation/sectionNavigation'
import HelmetWrapper from '../components/helmet/helmetWrapper'

const Page = ({
  pageContext: {
    activeLanguage,
    defaultLanguage,
    homepage,
    languages
  },
  data,
  location
}) => {
  const {
    allContentfulMetaHeader,
    allContentfulMetaFooter,
    contentfulPageLandingpage,
    allBegaEntryTags
  } = data

  // Pages with reduced padding
  const getReducedPaddingPageIds = () => {
    return [
      '2TysOfNQGN1kH3cqI6bDK7',
      '40ZAKP24I3eOalDPew2M6y',
      '1m35Tf39r4ZTmquE4FFWsz',
      '6GnyjnzYKLkZ1LtQnFVEIb',
      '9iQvCvlMBJ04M4lAPrZfh',
      '2RnvqUFHXd5B0CnPcoreoo',
      '4PDzQwO6nMQxxq9cgqn4y1'
    ]
  }

  const reducedPaddingPageIds = getReducedPaddingPageIds()
  const hasReducedPadding = reducedPaddingPageIds.includes(contentfulPageLandingpage.contentful_id)

  let localeHeader = null
  let localeFooter = null
  let sectionNav = []

  const langProps = {
    lang: languages,
    activeLang: activeLanguage,
    defaultLang: defaultLanguage,
    isHomepage: homepage
  }

  allContentfulMetaHeader.edges.forEach(metaHeader => {
    if (metaHeader.node.node_locale === langProps.activeLang) {
      localeHeader = metaHeader.node
    }
  })

  allContentfulMetaFooter.edges.forEach(metaFooter => {
    if (metaFooter.node.node_locale === langProps.activeLang) {
      localeFooter = metaFooter.node
    }
  })

  // Filter fragments for section navigation
  if (contentfulPageLandingpage.pagenavOption && contentfulPageLandingpage.fragments) {
    const filteredFragments = contentfulPageLandingpage.fragments
      .map(fragment => filterFragmentByTags(fragment, activeLanguage, allBegaEntryTags))
      .filter(Boolean);

    filteredFragments.forEach(fragment => {
      if (fragment.pageNavigation) {
        sectionNav.push({
          name: fragment.name,
          id: fragment.id
        })
      }
    })
  }

  useEffect(() => {
    const animatedEl = document.querySelectorAll('.js-gs-wrapper')

    if (animatedEl) {
      window.history.scrollRestoration = 'manual'
      window.onload = () => {
        if (window.scrollTo) window.scrollTo(0, 0);
      }

      mapAnimations()
    }
  }, [])





  return (
    <Layout 
      header={localeHeader} 
      lang={langProps} 
      location={location} 
      footer={localeFooter}
      reducedPadding={hasReducedPadding}
    >

      {contentfulPageLandingpage.seoJson &&
        <HelmetWrapper
          content={contentfulPageLandingpage.seoJson}
          activeLang={langProps.activeLang}
        />
      }

      {contentfulPageLandingpage.fragments && (() => {
        const filteredFragments = contentfulPageLandingpage.fragments
          .map(fragment => filterFragmentByTags(fragment, activeLanguage, allBegaEntryTags))
          .filter(Boolean);

        return filteredFragments.map((section, index) =>
          <Section key={section.id} section={section} id={index} max={filteredFragments.length} />
        );
      })()}



      {contentfulPageLandingpage.pagenavOption &&
        <SectionNav items={sectionNav} />
      }

    </Layout>
  )
}

export default Page

export const pageQuery = graphql`
  query PageByID($id: String!) {
    site {
      siteMetadata {
        title
        description
      }
    }
    
    allBegaContentTag {
      nodes {
        id
        name
        contentful_id
        visibility
      }
    }
    
    allBegaEntryTags {
      nodes {
        id
        contentful_id
        contentType
        title
        locale
        tags {
          id
          name
          contentful_id
        }
      }
    }
    
    allContentfulMetaHeader(filter: {headerActive: {eq: "Yes"}}) {
      edges {
        node {
          ...metaHeaderFields
          navigation {
            __typename
            ... on ContentfulMetaLink {
              ...metaLinkFields
            }
            ... on ContentfulPageLandingpage {
              ...pageLandingpageFields
            }
          }
          contactFieldMobile {
            __typename
            ... on ContentfulMetaLink {
              ...metaLinkFields
            }
          }
        }
      }
    }
    
    contentfulPageLandingpage(id: {eq: $id}) {
      ...pageLandingpageFields
      fragments {
        __typename
        ... on ContentfulFragmentSection {
          ...fragmentSectionFields
          contentful_id
          fragments {
            __typename
            ... on ContentfulFragmentHeadline {
              ...fragmentHeadlineFields
              contentful_id
            }
            ... on ContentfulFragmentRichText {
              ...fragmentRichTextFields
              contentful_id
            }
            ... on ContentfulFragmentMedia {
              ...fragmentMediaFields
              contentful_id
            }
            ... on ContentfulFragmentSlider {
              ...fragmentSliderFields
              contentful_id
            }
            ... on ContentfulFragmentHtml {
              ...fragmentHtmlFields
            }
            ... on ContentfulFragmentGallery {
              ...fragmentGalleryFields
              contentful_id
            }
          }
        }
      }
    }
    
    allContentfulMetaFooter(filter: {footerActive: {eq: "Yes"}}) {
      edges {
        node {
          id
          node_locale
          leftSection {
            __typename
            ... on ContentfulPageLandingpage {
              ...pageLandingpageFields
            }
            ... on ContentfulMetaLink {
              ...metaLinkFields
            }
          }
          centerSection {
            __typename
            ... on ContentfulPageLandingpage {
              ...pageLandingpageFields
            }
            ... on ContentfulMetaLink {
              ...metaLinkFields
            }
          }
          rightSection {
            __typename
            ... on ContentfulPageLandingpage {
              ...pageLandingpageFields
            }
            ... on ContentfulMetaLink {
              ...metaLinkFields
            }
          }
        }
      }
    }
  }
`
